/* eslint-disable prefer-template */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { Row, Col, Container } from 'reactstrap';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {
  Typography,
  Grid,
  IconButton,
} from '@material-ui/core';
import '../../shared/arial';
import Loader from 'react-loader-spinner';
import MaterialTable from 'material-table';
import { makeStyles } from '@material-ui/core/styles';
import { Loading, exportXlsx } from '../../helpers/utils';
import elearningDetailsServices from '../../redux/services/elearningDetailsServices';
import ScaleOralParticipation from './ExamType0Grades/ScaleOralParticipation';
import ScaleOralPresential from './ExamType0Grades/ScaleOralPresential';
import ScaleQuizOnPaper60Min from './ExamType0Grades/ScaleQuizOnPaper60Min';
import ScaleQuizOnPaper90Min from './ExamType0Grades/ScaleQuizOnPaper90Min';
import ScaleExamSemester4 from './ExamType0Grades/ScaleExamSemester4';
import ScaleExamSemester5 from './ExamType0Grades/ScaleExamSemester5';
import ScaleExamSemester6 from './ExamType0Grades/ScaleExamSemester6';
import ScaleOralPosterPresentation from './ExamType0Grades/ScaleOralPosterPresentation';
import ScaleOralCaseStudy from './ExamType0Grades/ScaleOralCaseStudy';
import ScaleOralRolePlay from './ExamType0Grades/ScaleOralRolePlay';
import examModalityServices from '../../redux/services/examModalityServices';
import ScaleExams from './ScaleExams';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
  },
  resultRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  gradeDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  totalGrade: {
    // color: '#000000',
    fontSize: '13px',
    fontWeight: 'bold',
  },
  resultDetail: {
    // color: '#666666',
    fontSize: '13px',
  },
}));

const ExamResultsWithGrades = ({ examIdentifier, examModalities }) => {
  const [loadingState, setLoadingState] = useState(true);
  const [substring, setSubstring] = useState(null);
  const [redirect, setRedirect] = useState(false);
  const [totalPapers, setTotalPapers] = useState(0);
  const [examModality, setExamModality] = useState({});
  const [exam, setExam] = useState({});
  const refTable = useRef();

  const [examData, setExamData] = useState([]);

  const classes = useStyles();

  const columns = [
    {
      title: 'Corrector',
      field: 'teacherId', // Peut rester vide si nous utilisons uniquement render()
      render: (rowData) => {
        if (rowData.teacherId && rowData.teacherId.firstname) {
          return <Typography variant="caption">{`${rowData.teacherId.firstname} ${rowData.teacherId.name}`}</Typography>;
        }
        return <Typography variant="caption">No corrector assigned</Typography>;
      },
    },
    {
      title: 'Name',
      field: 'name',
      hidden: !!exam.anonymous,
      defaultSort: 'asc',
    },
    {
      title: 'Firstname',
      field: 'firstname',
      hidden: !!exam.anonymous,
    },
    {
      title: 'Number',
      field: 'number',
      hidden: !exam.anonymous,
    },
    {
      title: 'Grade',
      field: 'results.grade',
      width: '40%',
      render: (rowData) => <ScaleExams rowData={rowData} examModality={examModality} />,
    },
    {
      title: 'Comment',
      field: 'results.comment',
      render: (rowData) => {
        if (rowData.comment !== 'No comment') {
          return (
            <Typography style={{ color: '#757575', fontSize: '13px' }}>
              {rowData.comment}
            </Typography>
          );
        }
        return <Typography variant="caption" style={{ color: '#8f8f8f' }}>No comment</Typography>;
      },
    },
  ];

  const loadExamResults = async () => {
    setLoadingState(true);
    const examRes = await elearningDetailsServices.getElearningDetailWithStudents(examIdentifier);
    if (examRes) {
      setExam(examRes.exam);
      if (examRes.exam.anonymous) {
        const formatedArray = [];
        let papers = 0;
        examRes.exam.results?.forEach((result) => {
          if (result.number) {
            formatedArray.push({
              teacherId: result.teacherId || 'No corrector assigned',
              number: result.number || '',
              grade: result.grade || 'No grade',
              comment: result.comment || 'No comment',
            });
            if (result.grade) {
              const grades = Object.values(result.grade);
              const sum = grades.reduce((a, b) => a + b);
              if (sum > 0) papers += 1;
            }
          }
        });
        setTotalPapers(papers);
        setExamData(formatedArray);
        setLoadingState(false);
      } else {
        const formatedArray = [];
        const examStudents = [];
        if (examRes.students) {
          examRes.students.forEach((student) => {
            if (parseFloat(student.semester, 10) === parseFloat(examRes.exam.semester, 10)
              || parseFloat(student.semester, 10) - 1 === parseFloat(examRes.exam.semester, 10)
              || student.catchUp?.includes(parseFloat(examRes.exam.semester, 10))) {
              examStudents.push(student);
            }
          });
          let papers = 0;
          examStudents.forEach((student) => {
            const studentObj = {
              teacherId: student.teacherId || 'No corrector assigned',
              userId: student._id,
              name: student.name,
              firstname: student.firstname,
              grade: 'No grade',
              comment: 'No comment',
            };
            if (examRes.exam.results !== undefined && examRes.exam.results.length > 0) {
              examRes.exam.results.forEach((result) => {
                if (result?.userId === student._id) {
                  studentObj.teacherId = result.teacherId || 'No corrector assigned';
                  studentObj.grade = result.grade;
                  studentObj.comment = result.comment || '/';
                }
              });
            }
            if (studentObj.grade && studentObj.grade !== 'No grade') {
              const grades = Object.values(studentObj.grade);
              const sum = grades.reduce((a, b) => a + b);
              if (sum > 0) papers += 1;
            }
            formatedArray.push(studentObj);
          });
          setTotalPapers(papers);
          setExamData(formatedArray);
          setLoadingState(false);
        }
      }
    }
  };

  useEffect(() => {
    examModalities.forEach((examModalityItem) => {
      if (examModalityItem.value === exam.modality) {
        setExamModality(examModalityItem);
      }
    });
  }, [exam]);

  useEffect(() => {
    loadExamResults();
  }, []);

  const handleRedirect = () => {
    setRedirect(true);
  };

  if (redirect) {
    return <Redirect to="/list" />;
  }
  return (
    <div className={classes.root}>
      <Container className="dashboard">
        <Row>
          <Col md={1} style={{ marginBottom: '20px' }}>
            <IconButton
              aria-label="delete"
              onClick={() => handleRedirect()}
            >
              <ArrowBackIcon />
            </IconButton>
          </Col>
        </Row>
      </Container>
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          {
            loadingState === false
              ? (
                <MaterialTable
                  style={{ width: '100%' }}
                  title={`Results for ${exam?.name ? exam.name.replace(/\b(level 1|level 2)\b\s*$/i, '') : ''} - Total papers: ${totalPapers || 0}`}
                  columns={columns}
                  isLoading={loadingState}
                  components={{
                    OverlayLoading: () => (<Loading />),
                  }}
                  localization={{
                    body: {
                      emptyDataSourceMessage: examData.length > 0 ? '' : 'No results to display',
                    },
                  }}
                  tableRef={refTable}
                  data={examData}
                  options={{
                    search: true,
                    exportButton: {
                      csv: true,
                      pdf: false,
                    },
                    exportCsv: () => {
                      const examObj = { ...exam } || null;
                      const finalResults = [];
                      const resultsArr = [...examData];
                      resultsArr.sort((a, b) => a.name > b.name);
                      resultsArr.forEach((elem) => {
                        const item = {};
                        if (exam.anonymous) {
                          item['Numéro'] = elem.number;
                        } else {
                          item.Nom = elem.name;
                          item['Prénom'] = elem.firstname;
                        }
                        // searching for grade since it's not in the base obj of the student
                        exam?.results?.forEach((result) => {
                          if (result.userId === elem.userId && result.grade !== undefined) {
                            const gradeArr = Object.values(elem.grade);
                            const totalGrade = gradeArr.reduce((a, b) => a + b);
                            let total = 0;
                            examModality.grades.forEach((gradeItem) => {
                              item[gradeItem.gradeFr] = elem.grade[gradeItem.gradeEn];
                              total += gradeItem.value;
                            });
                            if (total === 20) {
                              item['Note (/20'] = totalGrade;
                            } else {
                              item['Score (/' + total + ')'] = totalGrade;
                              item['Note (/20'] = (totalGrade / total) * 20;
                            }
                          }
                        });
                        if (elem.grade === undefined) {
                          item.grade = 'n/a';
                        }
                        if (exam && exam !== null) {
                          exam.results.forEach((result) => {
                            if (result.userId === item.userId) {
                              item.Commentaire = result.comment;
                            }
                          });
                        }
                        finalResults.push(item);
                      });
                      const today = new Date();
                      const sortedArr = finalResults.sort((a, b) => ((
                        a.Nom > b.Nom)
                        ? 1
                        : ((b.Nom > a.Nom)
                          ? -1
                          : 0)
                      ));
                      exportXlsx(sortedArr, `${examObj.name.replace(/\b(level 1|level 2)\b\s*$/i, '')}_${today.getDate()}/${today.getMonth() + 1}`);
                    },
                    exportAllData: true,
                    pageSize: examData.length,
                    sorting: true,
                  }}
                  onRowClick={(e, data) => {
                    if (substring !== data.userId) {
                      setSubstring(data.userId);
                    } else {
                      setSubstring(null);
                    }
                  }}
                />
              )
              : <Loader type="TailSpin" color="#3F51B5" height={40} width={40} />
          }
        </Grid>
      </Grid>
    </div>
  );
};

ExamResultsWithGrades.propTypes = {
  examIdentifier: PropTypes.string.isRequired,
  examModalities: PropTypes.array.isRequired,
};

export default ExamResultsWithGrades;
